module.exports = __webpack_public_path__ + "img/DNADamage-BRCA_her2st.10ffd478.png";